4/8/2026

import axios from 'axios'
import { useExecutiveAuthStore } from '../store/executiveAuthStore'

const BASE = (import.meta as any).env.VITE_API_BASE_URL || 'https://172.16.3.164:8001'

export const executiveClient = axios.create({ baseURL: BASE })

executiveClient.interceptors.request.use((config) => {
  const token = useExecutiveAuthStore.getState().token
  if (token) {
    config.headers['Authorization'] = `ExecutiveBearer ${token}`
  }
  return config
})

executiveClient.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status
    const requestUrl: string = err.config?.url || ''

    // Don't hard-redirect when the FAILING request is the login call itself.
    // A 401 from /executive/auth/login/ just means "wrong username/password" --
    // it should surface as a toast on the login form, not force a page reload.
    const isLoginRequest = requestUrl.includes('/executive/auth/login/')

    if ((status === 401 || status === 403) && !isLoginRequest) {
      useExecutiveAuthStore.getState().clearAuth()
      // Only reached for an EXPIRED SESSION on an already-authenticated route
      // (e.g. dashboard call failing with 401), not for a bad login attempt.
      window.location.href = '/executive/login'
    }

    return Promise.reject(err)
  }
)

export const executiveAPI = {
  login: (username: string, password: string) =>
    executiveClient.post('/executive/auth/login/', { username, password }),
  changePassword: (old_password: string, new_password: string) =>
    executiveClient.post('/executive/auth/change-password/', { old_password, new_password }),
  getDashboard: (params?: { page?: number; page_size?: number; trend_range?: string }) =>
    executiveClient.get('/executive/dashboard/', { params }),
}





















// import axios from 'axios'
// import { useExecutiveAuthStore } from '../store/executiveAuthStore'

// const BASE = (import.meta as any).env.VITE_API_BASE_URL || 'https://172.16.3.164:8000'

// // Exported (was module-private before) so other API modules — e.g.
// // monitoringApi.ts — can reuse the same instance, base URL, and
// // ExecutiveBearer/401 interceptors instead of duplicating them.
// export const executiveClient = axios.create({ baseURL: BASE })

// executiveClient.interceptors.request.use((config) => {
//   const token = useExecutiveAuthStore.getState().token
//   if (token) {
//     config.headers['Authorization'] = `ExecutiveBearer ${token}`
//   }
//   return config
// })

// executiveClient.interceptors.response.use(
//   (r) => r,
//   (err) => {
//     if (err.response?.status === 401 || err.response?.status === 403) {
//       useExecutiveAuthStore.getState().clearAuth()
//       window.location.href = '/executive/login'
//     }
//     return Promise.reject(err)
//   }
// )

// export const executiveAPI = {
//   login: (username: string, password: string) =>
//     executiveClient.post('/executive/auth/login/', { username, password }),
//   changePassword: (old_password: string, new_password: string) =>
//     executiveClient.post('/executive/auth/change-password/', { old_password, new_password }),
//   getDashboard: (params?: { page?: number; page_size?: number; trend_range?: string }) =>
//     executiveClient.get('/executive/dashboard/', { params }),
// }


// import axios from 'axios'
// import { useExecutiveAuthStore } from '../store/executiveAuthStore'

// const BASE = (import.meta as any).env.VITE_API_BASE_URL || 'https://172.16.3.164:8000'

// // Exported (was module-private before) so other API modules — e.g.
// // monitoringApi.ts — can reuse the same instance, base URL, and
// // ExecutiveBearer/401 interceptors instead of duplicating them.
// export const executiveClient = axios.create({ baseURL: BASE })

// executiveClient.interceptors.request.use((config) => {
//   const token = useExecutiveAuthStore.getState().token
//   if (token) {
//     config.headers['Authorization'] = `ExecutiveBearer ${token}`
//   }
//   return config
// })

// executiveClient.interceptors.response.use(
//   (r) => r,
//   (err) => {
//     if (err.response?.status === 401 || err.response?.status === 403) {
//       useExecutiveAuthStore.getState().clearAuth()
//       window.location.href = '/executive/login'
//     }
//     return Promise.reject(err)
//   }
// )

// export const executiveAPI = {
//   login: (username: string, password: string) =>
//     executiveClient.post('/executive/auth/login/', { username, password }),
//   changePassword: (old_password: string, new_password: string) =>
//     executiveClient.post('/executive/auth/change-password/', { old_password, new_password }),
//   getDashboard: (params?: { page?: number; page_size?: number }) =>
//     executiveClient.get('/executive/dashboard/', { params }),
// }